export const PostFile = ({file}) =>{

  let filename = file.filename;
  let ext = "";

  const base_with_ext = file.filename.match(/(.*)(\.[^.]*)$/).slice(1)

  if (base_with_ext.length === 2) {
    filename = base_with_ext[0];
    ext = base_with_ext[1];
  }


  return <a href={file.download_url} target={'_blank'}  className={'postFileContainer'} download>
        <div className={'containerNamePictoFile'}>
            <div className={'filePicto'}/>
            <div className={'fileName'}>{filename}</div>
            { ext && <div className={'fileExt'}>{ext}</div>}
        </div>
        <div className={'flechePicto'}/>
    </a>
}
